import { api } from "./client.js";

export const integrationsApi = {
  calendarStatus: () => api.get<{ enabled: boolean }>("/api/integrations/calendar/status"),
  enableCalendar: () =>
    api.post<{ token: string; url: string }>("/api/integrations/calendar/enable"),
  disableCalendar: () => api.post<{ disabled: boolean }>("/api/integrations/calendar/disable"),
  // Same-origin download (the session cookie rides along).
  markdownHref: "/api/integrations/export.md",
};
